import React from 'react';
import PropTypes from 'prop-types';
import { FiTrash2 } from 'react-icons/fi';

const EmailDraftDeleteButton = ({ draft, onDelete = () => {} }) => (
    <FiTrash2
        onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onDelete(draft);
        }}
        className="icon delete"
    />
);

EmailDraftDeleteButton.propTypes = {
    draft: PropTypes.object,
    onDelete: PropTypes.func,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    compact: PropTypes.bool,
    title: PropTypes.string,
    ariaLabel: PropTypes.string,
};

export default EmailDraftDeleteButton;
